exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#delete-all .custom-control-input:checked ~ .custom-control-label::before {\n  color: #fff;\n  border-color: #fff;\n  background-color: #00a09c;\n}\n", ""]);

// exports
